/**
 * @typedef {Object} CentroCusto
 * @property {string} id
 * @property {string} nome
 * @property {string} codigo
 * @property {string} apelido
 */

/**
 * @typedef {Object} CentroCustoResponse
 * @property {CentroCusto[]} centrosCustos
 * @property {number} total
 * @property {number} page
 */

/**
 * @typedef {Object} Filters
 * @property {number} page
 * @property {number} pageSize
 * @property {string} [nome]
 * @property {string} [apelido]
 * @property {string} [codigo]
 */

// Configuração do mock
const TOTAL_REGISTROS_MOCK = 100;

/**
 * Mock que simula o comportamento real do backend
 * 
 * Frontend envia: page, pageSize, filtros
 * Backend retorna: APENAS os registros daquela página + total geral
 * 
 * Exemplo:
 * - Página 1 (pageSize 25): retorna itens 1-25, total: 100
 * - Página 2 (pageSize 25): retorna itens 26-50, total: 100
 * - Página 3 (pageSize 25): retorna itens 51-75, total: 100
 * - Página 4 (pageSize 25): retorna itens 76-100, total: 100
 * 
 * @param {Filters} filters
 * @returns {CentroCustoResponse}
 */
export const CentroCustoTableMockResponse = (filters) => {
  const centrosCustos = [];
  
  const startIndex = (filters.page - 1) * filters.pageSize;
  
  for (let i = 0; i < filters.pageSize; i++) {
    const itemNumber = startIndex + i + 1;
    
    if (itemNumber <= TOTAL_REGISTROS_MOCK) {
      centrosCustos.push({
        id: `${itemNumber}`,
        nome: `Centro ${itemNumber}`,
        codigo: `CC${itemNumber.toString().padStart(3, '0')}`,
        apelido: `C${itemNumber}`
      });
    }
  }
  
  return {
    centrosCustos,
    total: TOTAL_REGISTROS_MOCK,
    page: filters.page
  };
};

